import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { paymentsAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import { useCompany } from '../common/useCompany';
import FxAmount from '../common/FxAmount';
import { Trash2 } from 'lucide-react';
import { docAmount } from '../../utils/currency';
export default function PaymentList() {
  const { hasPermission } = useAuth(); const navigate = useNavigate();
  const company = useCompany();
  const base = company?.base_currency || 'USD';
  const [tab, setTab] = useState('customer'); const [payments, setPayments] = useState([]); const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true);
    const fn = tab === 'customer' ? paymentsAPI.customerList : paymentsAPI.vendorList;
    fn({}).then(setPayments).catch(e => toast.error(e.message)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [tab]);
  const canDelete = hasPermission('payments:void') || hasPermission('payments:create');
  const doDelete = async (p) => {
    if (!window.confirm(`Delete payment ${p.payment_number}? This cannot be undone.`)) return;
    try {
      const fn = tab === 'customer' ? paymentsAPI.customerDelete : paymentsAPI.vendorDelete;
      await fn(p.id);
      toast.success('Payment deleted');
      load();
    } catch (e) { toast.error(e.message); }
  };
  return (
    <div>
      <div className="toolbar"><h2>Payments</h2>
        <div className="toolbar-right">{hasPermission('payments:create') && <button className="btn btn-primary" onClick={() => navigate(`/payments/new?type=${tab}`)}>+ New Payment</button>}</div>
      </div>
      <div className="tabs">
        <button className={`tab ${tab==='customer'?'active':''}`} onClick={()=>setTab('customer')}>Customer Payments</button>
        <button className={`tab ${tab==='vendor'?'active':''}`} onClick={()=>setTab('vendor')}>Vendor Payments</button>
      </div>
      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card"><div className="card-body" style={{padding:0}}>
          <table>
            <thead><tr><th>Payment #</th><th>{tab==='customer'?'Customer':'Vendor'}</th><th>Date</th><th>Method</th><th>Currency</th><th className="text-right">Amount</th><th>Status</th><th className="text-right">Actions</th></tr></thead>
            <tbody>
              {payments.map(p => {
                const fx = docAmount(p, base);
                return (
                  <tr key={p.id} onClick={() => navigate(`/payments/${p.id}?type=${tab}`)} style={{ cursor: 'pointer' }}>
                    <td className="font-mono">{p.payment_number}</td><td>{p.customer_name || p.vendor_name}</td><td>{p.payment_date}</td>
                    <td>{p.payment_method}</td>
                    <td>
                      {fx.currency}
                      {fx.isForeign && (
                        <span style={{ display: 'block', fontSize: 11, color: '#94a3b8' }}>
                          1 {fx.currency} = {fx.rate.toLocaleString('en-US', { maximumFractionDigits: 4 })} {fx.base}
                        </span>
                      )}
                    </td>
                    {/* Shown in the currency the payment was made in, with the
                        base-currency equivalent underneath — never relabelled
                        as the base currency. */}
                    <td className="amount">
                      <FxAmount
                        amount={p.amount}
                        currency={p.currency}
                        exchangeRate={p.exchange_rate}
                        baseAmount={p.base_amount}
                        baseCurrency={base}
                        style={{ textAlign: 'right' }}
                      />
                    </td>
                    <td><span className={`badge badge-${p.status?.toLowerCase()}`}>{p.status}</span></td>
                    <td className="text-right" onClick={e => e.stopPropagation()}>
                      {p.status === 'Draft' && canDelete && (
                        <button className="btn btn-ghost btn-sm" title="Delete" onClick={() => doDelete(p)}><Trash2 size={13} /></button>
                      )}
                    </td>
                  </tr>
                );
              })}
              {payments.length === 0 && <tr><td colSpan={8} className="text-center text-muted" style={{padding:30}}>No payments found</td></tr>}
            </tbody>
          </table>
        </div></div>
      )}
    </div>
  );
}